import {clone} from 'lodash';
import { createLogger } from 'shared/services/logger';
import us from '../../defines';
import {getImageIdFromSrcAttr, isNumber} from '../../lib/utility/helpers';
import app from '../../public-api';
import {translate} from 'shared/services/I18nService';
const $t = translate.scope('uScope.extensions.label');

const logger = createLogger('UScope:extensions:Label');

const defaults = {
  layout: {'divClass': us.clsDIVLABEL, 'precinct': 'TR', 'order': 1}
};

export default function Label (uScope, viewport, userConfig) {
  var self = this;
  var isLoaded = false; // label has been loaded

  var jVpDiv = viewport.vpDivGet('outer');
  var jLabelDiv;

  var angleDeg = 0; // the label's angle of rotation in degrees

  var prefVisibleDef = true; // label visibility preference default
  var prefRotationDef = 0; // label rotation default

  var navModesImHiddenIn = {}; // what navigation modes not to display the label

  var layout = clone(defaults.layout);
  var reLayout = viewport.overLayout.refreshPrecinct;

  // ............................................ construct_ local
  var construct_ = function () {
    navModesImHiddenIn[us.eNavModes.nmRasterScan] = true; // hide label in rasterscan mode
    us.setAnnotNavModes(navModesImHiddenIn); // hide label when drawing any annotation

    // if the label has been disabled (TODO: or the user does not have rights to view it), don't load it
    if (!us.ENABLELABEL) {
      return;
    }
    // if this image has no label, return
    if (!viewport.hasALabel()) {
      return;
    }

    load_(); // load the label image

    // ..................................................
    // closure functions
    // ............................................ load_()
    //    This function loads the label image div and, when the image loaded,
    //    calls into the layout manager to position it according to its layout settings.
    function load_ () {
      if (jLabelDiv) return; // if this viewport already has a label div, return

      // first create an offscreen div that will contain the Label img and add it to the vp
      jLabelDiv = $('<div/>', { // build the div tag that contains the img tag
        'class': us.clsDIVLABEL + ' ' + us.clsOVERLAY,
        'title': $t('image-label-title'), // tooltip
        css: {'left': us.kDEF_TILE_POS_PX, 'top': us.kDEF_TILE_POS_PX}
      });
      jVpDiv.append(jLabelDiv); // place the label div in the vp
      jLabelDiv = jVpDiv.find('.' + us.clsDIVLABEL);

      // next build the image tag and load the label image
      // BROWSER_FIX_HERE: the label is requested as a square so FF rotation leaves space in layout manger who doesn't know if it is rotated

      var sLabelImgSrc = viewport.urlBuilder.label(us.labelSpecs.width, us.labelSpecs.width);

      $('<img/>', { // place the labelImg in the DOM's label div
        load: function (e) {
          // check that this viewport's imageId === this image source's imageId
          var srcId = getImageIdFromSrcAttr(e.currentTarget); // format "@2"
          if (viewport.getImageId() !== srcId) { // if they don't match, do not load this thumbnaail (async return from another image!)
            logger.warn('...label:load: vpDiv id=' + viewport.getImageId() + '  srcId=' + srcId + ' - skipping load!!');
            return;
          }
          if (isLoaded == true) { // don't load the same label multiple times (happens when VIL reopens same image)
            logger.warn('...label:load: Label image for (' + viewport.getImageId() + ') received again!!');
            return;
          }
          isLoaded = true;

          jLabelDiv.append(e.currentTarget); // place the labelImg in the DOM's label div in the viewport
          viewport.overLayout.add(layout); // and call into layout with parms to place the div

          rotate_(userConfig.get('labelRotation'), 'absolute');
          self.show(prefVisibleDef);
        },
        error: function (e) {
          logger.error('label:load: error');
        },
        'class': us.clsIMGLABEL,
        'src': sLabelImgSrc,
        'alt': ''
      });
      bindEvents_(); // add event handlers
    }
    // ............................................ bindEvents_()
    // bindEvents_ - This function adds the  label event handlers.
    //
    //    Note that by using the same namespace as the viewport when the
    //    viewport removes its events by namespace, these are also removed.

    function bindEvents_ () {
      var namespace = viewport.eventNameSpaceGet();

      // show/hide label on mode change
      $(us.idHashROOT).on(us.evMODECHANGE + namespace, function (e, parms) {
        // show is true if this is the image selected and not in a mode that I'm supposed to hide during
        var bshow = !!((viewport.getImageIdx() == uScope.getSelImageIdx() && navModesImHiddenIn[parms.navMode] == undefined));
        self.show(bshow);
      });
      // show/hide label if image is selected/not-selected
      $(us.idHashROOT).on(us.evIMAGESELECTED + namespace, function (e, parms) {
        if (viewport.sampleTypeIsControl() == true) { self.show(true); } else { self.show(parms.uScopeIdx == viewport.getImageIdx()); }
      });

      // user preference update
      $(us.idHashROOT).on(us.evUSERPREFSREADY + namespace, function (e, parms) {
        self.show(userConfig.get(us.clsDIVLABEL));
        rotate_(userConfig.get('labelRotation'), 'absolute');
      });
      $(us.idHashROOT).on(us.evUSERPREFSET + namespace, function (e, parms) { // parms: {className: STR, value: bool}
        if (parms.className == us.clsDIVLABEL) {
          self.show(parms.value);
          rotate_(userConfig.get('labelRotation'), 'absolute');
        }
      });
      $(us.idHashROOT).on(us.evUSERPREFDEFAULTLABELROT + namespace, function (e, parms) {
        userConfig.set('labelRotation', prefRotationDef);
      });

      // prevent dblclick on label causing double click zoom on viewport
      // capture mousedown so event does not propigate to viewport and close open dialogs
      jLabelDiv.on('mousedown' + namespace + ' dblclick' + namespace, function (e) {
        return false;
      });

      jLabelDiv.on('click' + namespace, function (e) {
        viewport.setImageSelected(); // inform uScope that this image is in focus
        rotate_(90, 'relative');
        e.preventDefault();
        return false;
      });
    }
    // ..................................................
  };

    // ............................................ get/set() public
  this.getViewAngle = function () {
    return angleDeg;
  };

  // ............................................ show() public
  this.show = function (show) {
    if (isLoaded == false) return;

    // prevent show if preference is not to show
    if (userConfig.get(us.clsDIVLABEL) == false) jLabelDiv.hide();
    else if (show == true) jLabelDiv.show();
    else jLabelDiv.hide();

    reLayout(layout.precinct); // layout just this overlay's precinct
  };

  // ............................................ rotate_() local
  //    This function rotates the label.
  //    parameters:
  //        nDegrees    : angle in degrees
  //        relOrAbs    : { "relative or "absolute" }
  //                        if "relative" the label is rotated the current angle + nDegrees clockwise
  //                        if "absolute" the label is rotated nDegrees clockwise
  //    returns:    none
  //    limitations - only 90 degree angles are implemented
  //
  //    improvements:
  //        - would it be better to have a circular array of rotation classes rather than build the string?
  //        - when tiled images are implemented this will have to select the proper image
  //
  // Label Rotation: http://answers.oreilly.com/topic/1004-how-to-rotate-an-image-with-css/
  //    http://www.communitymx.com/content/article.cfm?cid=6DA05
  //
  var rotate_ = function (nDegrees, relOrAbs) {
    if (jLabelDiv == undefined || isNumber(nDegrees) == false) return;
    if (us.ENABLELABEL == false || isLoaded == false) return;
    if ((nDegrees % 90) != 0) nDegrees = 0;

    var curRotationClass = us.ROTATE + angleDeg;

    var newRotation = (relOrAbs == 'relative') ? (+angleDeg + nDegrees) % 360 : +nDegrees;
    var newRotationClass = us.ROTATE + newRotation;

    jLabelDiv.removeClass(curRotationClass).addClass(newRotationClass);
    publishRotateEvent(newRotation);

    angleDeg = newRotation;
  };

  function publishRotateEvent (newDegree) {
    const rotationDetails = {
      newDegree
    };
    app.events.trigger('us:label:rotation-changed', rotationDetails);
  };
  // ............................................ construction
  construct_();
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/label/label.js